module.exports = __webpack_public_path__ + "img/zhiyuan.1641520899224.png";